var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3288_12113)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#095D7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3334 32V29.3333C26.3334 27.9188 25.7714 26.5623 24.7713 25.5621C23.7711 24.5619 22.4145 24 21 24H13C11.5855 24 10.229 24.5619 9.22878 25.5621C8.22859 26.5623 7.66669 27.9188 7.66669 29.3333V32",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3334 32V29.3333C26.3334 27.9188 25.7714 26.5623 24.7713 25.5621C23.7711 24.5619 22.4145 24 21 24H13C11.5855 24 10.229 24.5619 9.22878 25.5621C8.22859 26.5623 7.66669 27.9188 7.66669 29.3333V32",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 19.6667C20.2789 19.6667 22.6667 17.2789 22.6667 14.3333C22.6667 11.3878 20.2789 9 17.3333 9C14.3878 9 12 11.3878 12 14.3333C12 17.2789 14.3878 19.6667 17.3333 19.6667Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.335,
    y: 1.335,
    width: 31.33,
    height: 31.33,
    rx: 15.665,
    stroke: "white",
    strokeWidth: 2.67
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3288_12113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileWhite);
export default __webpack_public_path__ + "static/media/profile-white.4f2a6c53f681b21214417d6f708c795b.svg";
export { ForwardRef as ReactComponent };